import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import UniversalInputComponent from "../universalInputComponent/UniversalInputComponent";
import TableAppBoatRegRHF from "../tableAppBoatRegRHF/TableAppBoatRegRHF";
import ResultModalWindow from "../ResultModalWindow/ResultModalWindow";
import ReasonRejectModalWindow from "../../../GeneralComponents/reasonRejectModalWindow/ReasonRejectModalWindow";
import { ProgressBar } from "react-loader-spinner";

import { ownerInfo, boatInfo } from "./optionsDecisionCardRHF";

import {
  boatCardAppDealsDtoList,
  boatCardAppEngDtoList,
  boatCardAppEngStaticDtoList,
  boatCardAppSmDtoList,
  setOptionsEngType,
} from "../../appBoatRegistrationRHF/optionsAppBoatRegistrationRHF";

import {
  boatCardSpecmarksList,
  boatCardModifDealsDtoList,
} from "../../registrationInformationChanges/IndividualStatement/optionsForIndividualStatement";

import {
  clearDecisionData,
  getDecisionCardInfo,
} from "../../../../redux/statementReducer/actionsStatement";
import { getDuplicateDecisionCardInfo } from "../../../../redux/DuplicateShipsTicketReducer/actionsDuplicateShipsTicket";
import { getShipsTicketDecisionInfo } from "../../../../redux/ShipsTicketReducer/actionsShipsTicket";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";
import {
  MAIN_URL,
  PORT,
  API_ACCEPT_BOAT_REGISTRATION,
  API_DECLINE_BOAT_REGISTRATION,
  API_ACCEPT_DUPLICATE,
  API_DECLINE_DUPLICATE,
  API_GET_STATEMENT_MODIF_INFO,
  API_ACCEPT_BOAT_MODIF,
  API_DECLINE_BOAT_MODIF,
  API_ACCEPT_SHIPS_TICKET,
  API_DECLINE_SHIPS_TICKET,
  API_PRINT_SHIPS_TICKET,
} from "../../../../constants/constants";

import styles from "./decisionCardRHF.module.css";

export default function DecisionCardRHF() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
  } = useForm({
    defaultValues: {
      ticketDateNew: new Date()
        .toLocaleDateString()
        .split(".")
        .reverse()
        .join("-"),
    },
  });
  const [isLoading, setIsLoading] = useState(true);
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [boatRegNum, setBoatRegNum] = useState(null);
  const [newData, setNewData] = useState({
    ticketDateNew: new Date()
      .toLocaleDateString()
      .split(".")
      .reverse()
      .join("-"),
  });
  const [changeInfData, setChangeInfData] = useState(null);
  const [acceptBtnText, setAcceptBtnText] = useState("");
  const [accessOptions, setAccessOptions] = useState({});
  const [errorText, setErrorText] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [reasonReject, setReasonReject] = useState("");
  const [handleRefuseApplication, setHandleRefuseApplication] = useState(() => {
    return function (reasonReject) {};
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { additionalAccess } = location.state;

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  const appRegistrationDecisionData = useSelector((state) => {
    const { statementReducer } = state;
    return statementReducer;
  });
  const appDuplicateDecisionData = useSelector((state) => {
    const { DuplicateShipsTicketReducer } = state;
    return DuplicateShipsTicketReducer;
  });
  const appShipsTicketDecisionData = useSelector((state) => {
    const { ShipsTicketReducer } = state;
    return ShipsTicketReducer;
  });

  let data = null;
  switch (true) {
    case window.location.pathname.includes("smallboatsreg"):
      data = { ...appRegistrationDecisionData.appDecisionData };
      break;
    case window.location.pathname.includes("dupshipsticket"):
      data = { ...appDuplicateDecisionData.appDecisionData };
      break;
    case window.location.pathname.includes("shipsticket"):
      data = { ...appShipsTicketDecisionData.appDecisionData };
      break;
    case window.location.pathname.includes("reginformationchanges"):
      data = changeInfData;
      break;
    default:
      break;
  }

  let state = null;
  switch (true) {
    case window.location.pathname.includes("smallboatsreg"):
      state = { ...appRegistrationDecisionData };
      break;
    case window.location.pathname.includes("dupshipsticket"):
      state = { ...appDuplicateDecisionData };
      break;
    case window.location.pathname.includes("shipsticket"):
      state = { ...appShipsTicketDecisionData };
      break;
    case window.location.pathname.includes("reginformationchanges"):
      state = changeInfData;
      break;
    default:
      break;
  }

  const handleCustomValidation = (data, key) => {
    if (new Date(data) > new Date()) {
      setError(key, {
        type: "manual",
        message: "Дата не может быть позднее текущей",
      });
      return false;
    } else {
      clearErrors(key);
      return true;
    }
  };

  const handleReasonReject = (value) => {
    setReasonReject(value);
  };

  const handleCloseRejectModal = () => {
    setReasonReject("");
    setShowRejectModal(false);
  };

  const resolveSubmit = async (formData) => {
    let request;
    const pathArray = window.location.pathname.split("/");
    const id = pathArray[pathArray.length - 1];
    const tableKey = pathArray[pathArray.length - 2];
    switch (true) {
      case window.location.pathname.includes("/shipsticket"):
        request = await fetchWithToken(
          MAIN_URL +
            PORT +
            API_PRINT_SHIPS_TICKET +
            "?" +
            new URLSearchParams({
              [`${tableKey}`]: id,
            }),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          },
        );
        break;
      case window.location.pathname.includes("dupshipsticket"):
        if (handleCustomValidation(newData.ticketDateNew, "ticketDateNew")) {
          request = await fetchWithToken(
            MAIN_URL +
              PORT +
              API_PRINT_SHIPS_TICKET +
              "?" +
              new URLSearchParams({
                [`boatCardAppDupId`]: id,
              }),
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(newData),
            },
          );
        }
        break;
      default:
        break;
    }
    if (request.status !== 200) {
      setRegistrationResult("error");
      if (request.status === 417) {
        let errorText = (await request.json().then((data) => data.message)) || (await request.text());
        setErrorText(errorText);
      }
      setShowResultModal(!showResultModal);
    } else {
      let response;
      if (
        window.location.pathname.includes("/shipsticket") ||
        window.location.pathname.includes("/dupshipsticket")
      ) {
        response = await request.formData();
        const handleFile = async (res) => {
          const filePdf = res.get("pdf");
          const fileUrl = URL.createObjectURL(filePdf);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = filePdf.name;
          link.click();
        };
        await handleFile(response);
      } else {
        response = await request.text();
      }
      // const response = await request.text();
      switch (true) {
        case window.location.pathname.includes("smallboatsreg"):
          setBoatRegNum(response);
          break;
        case window.location.pathname.includes("reginformationchanges"):
          setBoatRegNum(response);
          break;
        case window.location.pathname.includes("/shipsticket"):
          setBoatRegNum(newData.tiketNumNew);
          break;
        case window.location.pathname.includes("dupshipsticket"):
          setBoatRegNum(newData.tiketNumNew);
          break;
        default:
          break;
      }
      setShowResultModal(!showResultModal);
      setRegistrationResult("success");
    }
  };

  const handleButtonClick = async (e) => {
    if (e) {
      switch (e.target.id) {
        case "close":
          navigate(-1);
          break;

        case "accept": {
          let request;
          const pathArray = window.location.pathname.split("/");
          const id = pathArray[pathArray.length - 1];
          const tableKey = pathArray[pathArray.length - 2];
          switch (true) {
            case window.location.pathname.includes("smallboatsreg"):
              request = await fetchWithToken(
                MAIN_URL + PORT + API_ACCEPT_BOAT_REGISTRATION + data.appId,
                {
                  method: "POST",
                },
              );
              break;
            case window.location.pathname.includes("/shipsticket"):
              request = await fetchWithToken(
                MAIN_URL +
                  PORT +
                  API_ACCEPT_SHIPS_TICKET +
                  "?" +
                  new URLSearchParams({
                    [`${tableKey}`]: id,
                  }),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(newData),
                },
              );
              break;
            case window.location.pathname.includes("dupshipsticket"):
              request = await fetchWithToken(
                MAIN_URL + PORT + API_ACCEPT_SHIPS_TICKET + data.appId,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(newData),
                },
              );
              break;
            case window.location.pathname.includes("reginformationchanges"):
              request = await fetchWithToken(
                MAIN_URL + PORT + API_ACCEPT_BOAT_MODIF + id,
                // + "/" + data.inspector,
                {
                  method: "POST",
                },
              );
              break;

            default:
              break;
          }
          if (request.status !== 200) {
            setRegistrationResult("error");
            if (request.status === 417) {
              setErrorText(await request.text());
            }
            setShowResultModal(!showResultModal);
          } else {
            const response = await request.text();
            switch (true) {
              case window.location.pathname.includes("smallboatsreg"):
                setBoatRegNum(response);
                break;
              case window.location.pathname.includes("reginformationchanges"):
                setBoatRegNum(response);
                break;
              case window.location.pathname.includes("/shipsticket"):
                setBoatRegNum(newData.tiketNumNew);
                break;
              case window.location.pathname.includes("dupshipsticket"):
                setBoatRegNum(newData.tiketNumNew);
                break;
              default:
                break;
            }
            setShowResultModal(!showResultModal);
            setRegistrationResult("success");
          }
          break;
        }

        case "decline": {
          let request;
          const pathArray = window.location.pathname.split("/");
          const declineId = pathArray[pathArray.length - 1];
          const tableKey = pathArray[pathArray.length - 2];
          switch (true) {
            case window.location.pathname.includes("smallboatsreg"):
              setHandleRefuseApplication(() => {
                return async (currentReasonReject) => {
                  const request = await fetchWithToken(
                    MAIN_URL +
                      PORT +
                      API_DECLINE_BOAT_REGISTRATION +
                      data.appId,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        reasonReject: currentReasonReject,
                      }),
                    },
                  );
                  if (request.status !== 200) {
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("error");
                  } else {
                    const response = await request.text();
                    if (
                      window.location.pathname.includes("smallboatsreg") ||
                      window.location.pathname.includes("dupshipsticket")
                    ) {
                      setBoatRegNum(response);
                    }
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                  }
                };
              });
              setShowRejectModal(true);
              return;
            case window.location.pathname.includes("/shipsticket"):
              setHandleRefuseApplication(() => {
                return async (currentReasonReject) => {
                  const request = await fetchWithToken(
                    MAIN_URL +
                      PORT +
                      API_DECLINE_SHIPS_TICKET +
                      "?" +
                      new URLSearchParams({
                        [`${tableKey}`]: declineId,
                      }),
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        reasonReject: currentReasonReject,
                      }),
                    },
                  );
                  if (request.status !== 200) {
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("error");
                  } else {
                    const response = await request.text();
                    if (
                      window.location.pathname.includes("smallboatsreg") ||
                      window.location.pathname.includes("dupshipsticket")
                    ) {
                      setBoatRegNum(response);
                    }
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                    setBoatRegNum("Refuse");
                  }
                };
              });
              setShowRejectModal(true);

              return;
            case window.location.pathname.includes("dupshipsticket"):
              setHandleRefuseApplication(() => {
                return async (currentReasonReject) => {
                  const request = await fetchWithToken(
                    MAIN_URL + PORT + API_DECLINE_DUPLICATE + data.appId,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        reasonReject: currentReasonReject,
                      }),
                    },
                  );
                  if (request.status !== 200) {
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("error");
                  } else {
                    const response = await request.text();
                    if (
                      window.location.pathname.includes("smallboatsreg") ||
                      window.location.pathname.includes("dupshipsticket")
                    ) {
                      setBoatRegNum(response);
                    }
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                    setBoatRegNum("Refuse");
                  }
                };
              });
              setShowRejectModal(true);

              return;
              request = await fetchWithToken(
                MAIN_URL + PORT + API_DECLINE_DUPLICATE + data.appId,
                {
                  method: "POST",
                },
              );

              break;
            case window.location.pathname.includes("reginformationchanges"):
              setHandleRefuseApplication(() => {
                return async (currentReasonReject) => {
                  const pathArray = window.location.pathname.split("/");
                  const id = pathArray[pathArray.length - 1];
                  const request = await fetchWithToken(
                    MAIN_URL + PORT + API_DECLINE_BOAT_MODIF + id,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        reasonReject: currentReasonReject,
                      }),
                    },
                  );
                  if (request.status !== 200) {
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("error");
                  } else {
                    const response = await request.text();
                    if (
                      window.location.pathname.includes("smallboatsreg") ||
                      window.location.pathname.includes("dupshipsticket")
                    ) {
                      setBoatRegNum(response);
                    }
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                    setBoatRegNum("Refuse");
                  }
                };
              });
              setShowRejectModal(true);

              return;
            // const pathArray = window.location.pathname.split("/");
            // const id = pathArray[pathArray.length - 1];
            // request = await fetchWithToken(
            //   MAIN_URL + PORT + API_DECLINE_BOAT_MODIF + id,
            //   {
            //     method: "POST",
            //   },
            // );
            // break;
            default:
              break;
          }
          if (request) {
            if (request.status !== 200) {
              setShowResultModal(!showResultModal);
              setRegistrationResult("error");
            } else {
              const response = await request.text();
              if (
                window.location.pathname.includes("smallboatsreg") ||
                window.location.pathname.includes("dupshipsticket")
              ) {
                setBoatRegNum(response);
              }
              setShowResultModal(!showResultModal);
              setRegistrationResult("success");
            }
          }
        }
        default:
          break;
      }
    }
  };
  const handleCloseCard = () => {
    dispatch(clearDecisionData());
    navigate(-1);
  };

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    const id = pathArray[pathArray.length - 1];
    switch (true) {
      case pathArray.includes("smallboatsreg"):
        dispatch(getDecisionCardInfo(id));
        setAcceptBtnText("Зарегистрировать судно");
        break;
      case pathArray.includes("dupshipsticket"):
        dispatch(getDuplicateDecisionCardInfo(id));
        setIsLoading(false);
        setAcceptBtnText("Распечатать");
        break;
      case pathArray.includes("shipsticket"):
        const tableKey = pathArray[pathArray.length - 2];
        dispatch(getShipsTicketDecisionInfo(id, tableKey));
        setIsLoading(false);
        setAcceptBtnText("Распечатать");
        break;
      case pathArray.includes("reginformationchanges"):
        async function fetchData() {
          const response = await fetchWithToken(
            MAIN_URL + PORT + API_GET_STATEMENT_MODIF_INFO + String(id),
          );
          const responseData = await response.json();
          responseData.bodyMaterial = responseData.bodyMaterialValue;
          responseData.saCategory = responseData.saCategoryValue;
          responseData.fio = responseData.fio || responseData.nameLe;
          setChangeInfData(responseData);
          setIsLoading(false);
          setAcceptBtnText("Принять");
        }
        fetchData();
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (newData[name] !== value[name]) {
        newData[name] = value[name];
      }
      if (name === "ticketDateNew") handleCustomValidation(value[name], name);
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (Object.values(dictionaryReducer.allEngineTypes).length > 0) {
      setOptionsEngType(dictionaryReducer.allEngineTypes);
      setIsLoading(false);
    }
  }, [dictionaryReducer]);
  useEffect(() => {
    if (Object.values(dictionaryReducer.allEngineTypes).length > 0) {
      setOptionsEngType(dictionaryReducer.allEngineTypes);
      setIsLoading(false);
    }
  }, []);
  return (
    <>
      {isLoading ? (
        <div className={`d-flex flex-column align-items-center `}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      ) : (
        <div className={styles["content-container"]}>
          <div className={styles["header-block"]}>
            {window.location.pathname.includes("smallboatsreg") ? (
              <>
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>
                    {"Регистрационный номер заявления"}
                  </p>
                  <p className={styles["option-value"]}>{data.appNum || "—"}</p>
                </div>
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>
                    {"Дата подачи заявления"}
                  </p>
                  <p className={styles["option-value"]}>
                    {data.appDate || "—"}
                  </p>
                </div>
              </>
            ) : (
              <div>
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>
                    {"Регистрационный номер маломерного судна"}
                  </p>
                  <p className={styles["option-value"]}>
                    {data?.regNum || "—"}
                  </p>
                </div>
              </div>
            )}
          </div>
          <UniversalInputComponent
            options={ownerInfo}
            styles={styles}
            newData={data}
          />
          <UniversalInputComponent
            options={boatInfo}
            styles={styles}
            newData={data}
          />
          {state?.boatCardAppEngList?.length > 0 && (
            <TableAppBoatRegRHF
              typeTable={"boatCardAppEngList"}
              tableOptions={boatCardAppEngDtoList}
              mode={"view"}
              dataForTable={
                changeInfData ? changeInfData?.enginesList : undefined
              }
            />
          )}

          {state?.boatCardAppEngStaticDtoList?.length > 0 && (
            <TableAppBoatRegRHF
              typeTable={"boatCardAppEngStaticDtoList"}
              tableOptions={boatCardAppEngStaticDtoList}
              mode={"view"}
              dataForTable={
                changeInfData ? changeInfData?.enginesList : undefined
              }
            />
          )}
          <TableAppBoatRegRHF
            typeTable={"boatCardAppDealsList"}
            tableOptions={
              changeInfData
                ? boatCardModifDealsDtoList
                : boatCardAppDealsDtoList
            }
            mode={"view"}
            dataForTable={
              changeInfData ? changeInfData?.boatCardModifDealsList : undefined
            }
          />
          <TableAppBoatRegRHF
            typeTable={"boatCardAppSpecMarkList"}
            tableOptions={
              changeInfData ? boatCardSpecmarksList : boatCardAppSmDtoList
            }
            mode={"view"}
            dataForTable={
              changeInfData ? changeInfData?.boatCardSpecmarksList : undefined
            }
          />
          {window.location.pathname.includes("/shipsticket/decisioncard") ||
          window.location.pathname.includes("dupshipsticket") ? (
            <form onSubmit={handleSubmit(resolveSubmit)}>
              <div className={styles["input-container"]}>
                <label className={styles?.["label"]}>
                  {window.location.pathname.includes(
                    "/shipsticket/decisioncard",
                  )
                    ? "Номер судового билета"
                    : "Номер дубликата судового билета"}
                  <span className={styles["red-dot"]}>*</span>
                </label>
                <input
                  id={"tiketNumNew"}
                  type={"text"}
                  className={`${styles["form-input"]} 
                  ${errors["tiketNumNew"] ? styles["error-border"] : ""}
                  `}
                  placeholder={"Введите"}
                  {...register("tiketNumNew", {
                    required: "Заполните поле",
                  })}
                />
                {errors["tiketNumNew"] && (
                  <div style={{ color: "red" }}>
                    {errors["tiketNumNew"].message}
                  </div>
                )}
              </div>
              <div className={styles["input-container"]}>
                <label className={styles?.["label"]}>
                  {window.location.pathname.includes(
                    "/shipsticket/decisioncard",
                  )
                    ? "Дата выдачи судового билета"
                    : "Дата выдачи дубликата судового билета"}
                  <span className={styles["red-dot"]}>*</span>
                </label>
                <input
                  id={"ticketDateNew"}
                  type={"date"}
                  className={`${styles["form-input"]} 
                  ${errors["ticketDateNew"] ? styles["error-border"] : ""}
                  `}
                  {...register("ticketDateNew", {
                    required: `Заполните поле`,
                  })}
                />
                {errors["ticketDateNew"] && (
                  <div style={{ color: "red" }}>
                    {errors["ticketDateNew"].message}
                  </div>
                )}
              </div>
              <div className={styles["buttons-container"]}>
                <div
                  className={styles["close-button"]}
                  id={"close"}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Закрыть
                </div>
                {additionalAccess?.decline && (
                  <div
                    className={styles["decline-button"]}
                    id={"decline"}
                    onClick={(e) => handleButtonClick(e)}
                  >
                    Отказать
                  </div>
                )}
                {(window.location.pathname.includes(
                  "smallboatsreg/decisioncard/",
                ) ||
                  window.location.pathname.includes(
                    "reginformationchanges/decisioncard/",
                  )) &&
                additionalAccess?.accept ? (
                  <div
                    className={styles["reg-button"]}
                    id={"accept"}
                    onClick={(e) => handleButtonClick(e)}
                  >
                    {acceptBtnText}
                  </div>
                ) : (
                  (window.location.pathname.includes(
                    "/shipsticket/decisioncard",
                  ) ||
                    window.location.pathname.includes(
                      "dupshipsticket/decisioncard",
                    )) &&
                  data.boatCardStatus !== 0 &&
                  additionalAccess?.accept && (
                    <button
                      className={styles["reg-button"]}
                      id={"accept"}
                      // onClick={(e) => handleButtonClick(e)}
                    >
                      {acceptBtnText}
                    </button>
                  )
                )}
              </div>
            </form>
          ) : (
            <div className={styles["buttons-container"]}>
              <div
                className={styles["close-button"]}
                id={"close"}
                onClick={(e) => handleButtonClick(e)}
              >
                Закрыть
              </div>
              {additionalAccess?.decline && (
                <div
                  className={styles["decline-button"]}
                  id={"decline"}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Отказать
                </div>
              )}
              {(window.location.pathname.includes(
                "smallboatsreg/decisioncard/",
              ) ||
                window.location.pathname.includes(
                  "reginformationchanges/decisioncard/",
                )) &&
              additionalAccess?.accept ? (
                <div
                  className={styles["reg-button"]}
                  id={"accept"}
                  onClick={(e) => handleButtonClick(e)}
                >
                  {acceptBtnText}
                </div>
              ) : (
                (window.location.pathname.includes(
                  "/shipsticket/decisioncard",
                ) ||
                  window.location.pathname.includes(
                    "dupshipsticket/decisioncard",
                  )) &&
                data.boatCardStatus !== 0 &&
                additionalAccess?.accept && (
                  <button
                    className={styles["reg-button"]}
                    id={"accept"}
                    onClick={(e) => handleButtonClick(e)}
                  >
                    {acceptBtnText}
                  </button>
                )
              )}
            </div>
          )}
          {showRejectModal && (
            <ReasonRejectModalWindow
              show={showRejectModal}
              setShow={setShowRejectModal}
              headerText={"Введите причину отказа:"}
              handleReasonReject={handleReasonReject}
              handleCloseRejectModal={handleCloseRejectModal}
              handleRefuse={() => handleRefuseApplication(reasonReject)}
              textareaPlaceholder={"Введите причину отказа"}
            />
          )}

          {showResultModal && (
            <ResultModalWindow
              appId={boatRegNum}
              show={showResultModal}
              setShow={setShowResultModal}
              result={registrationResult}
              handleCloseApp={handleCloseCard}
              errorText={errorText}
            />
          )}
        </div>
      )}
    </>
  );
}
